import { render, staticRenderFns } from "./RegistrationFooter.vue?vue&type=template&id=4a773d8e&scoped=true&"
import script from "./RegistrationFooter.vue?vue&type=script&lang=js&"
export * from "./RegistrationFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a773d8e",
  null
  
)

export default component.exports